













































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ErrorAlert from "@/utility/ErrorAlert";
import { appModule } from "@/store/modules/app";
@Component({})
export default class CardModalTtd extends Vue {
  @Prop() readonly value!: boolean;
  @Prop({ type: Boolean, default: true }) readonly autoClose!: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: String, default: "" }) readonly hint!: string;

  password = "";
  showEye = false;
  rules = {
    required: value => !!value || "Required."
  };

  get msg() {
    return appModule.msgTtd;
  }

  get hintText() {
    return this.hint || "Maukkan PIN/ Password untuk Tandatangan Digital";
  }

  ttd() {
    if (this.loading) return;
    this.$emit("passTtd", this.password);
    if (this.autoClose) {
      this.show = false;
    }
    // this.password = "";
  }

  @Watch("value")
  changedValue(val) {
    if (!val) {
      this.password = "";
      appModule.addMsgTtd("");
    }
  }

  close() {
    this.show = false;
    this.password = "";
    appModule.addMsgTtd("");
  }

  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }
}
